/**
 * @generated SignedSource<<fbb56aff230f4fbedd42ab325d4c12ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type docktype = "DOCK" | "G47" | "GROUND" | "PEDESTAL" | "UNKNOWN" | "%future added value";
export type DocksRefetchQuery$variables = {
  count?: number | null;
  cursor?: string | null;
  dockTypes?: ReadonlyArray<docktype | null> | null;
  organizationUuid?: string | null;
  releaseUuid?: string | null;
  searchTerm?: string | null;
};
export type DocksRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DocksList_docks">;
};
export type DocksRefetchQuery = {
  response: DocksRefetchQuery$data;
  variables: DocksRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dockTypes"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationUuid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "releaseUuid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "dockTypes",
    "variableName": "dockTypes"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Variable",
    "name": "organizationUuid",
    "variableName": "organizationUuid"
  },
  {
    "kind": "Variable",
    "name": "releaseUuid",
    "variableName": "releaseUuid"
  },
  {
    "kind": "Variable",
    "name": "searchTerm",
    "variableName": "searchTerm"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skydioSerial",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vehicleId",
    "storageKey": null
  },
  (v3/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DocksRefetchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "DocksList_docks"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DocksRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DockConnection",
        "kind": "LinkedField",
        "name": "docks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DockEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Dock",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "uuid",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dockId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dockType",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "organizationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Release",
                    "kind": "LinkedField",
                    "name": "release",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "releaseKey",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "versionString",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOnline",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vehicle",
                    "kind": "LinkedField",
                    "name": "vehicle",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccessPoint",
                    "kind": "LinkedField",
                    "name": "accessPoint",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "searchTerm",
          "organizationUuid",
          "releaseUuid",
          "dockTypes"
        ],
        "handle": "connection",
        "key": "DocksList_docks",
        "kind": "LinkedHandle",
        "name": "docks"
      }
    ]
  },
  "params": {
    "cacheID": "046fe990e1855c974c6a65f32a755026",
    "id": null,
    "metadata": {},
    "name": "DocksRefetchQuery",
    "operationKind": "query",
    "text": "query DocksRefetchQuery(\n  $count: Int\n  $cursor: String\n  $dockTypes: [docktype]\n  $organizationUuid: String\n  $releaseUuid: String\n  $searchTerm: String\n) {\n  ...DocksList_docks\n}\n\nfragment DocksList_docks on Query {\n  docks(searchTerm: $searchTerm, organizationUuid: $organizationUuid, releaseUuid: $releaseUuid, dockTypes: $dockTypes, first: $count, after: $cursor) {\n    totalCount\n    edges {\n      node {\n        id\n        uuid\n        displayName\n        dockId\n        dockType\n        skydioSerial\n        organizationId\n        organization {\n          id\n          name\n        }\n        release {\n          id\n          releaseKey\n          versionString\n        }\n        isOnline\n        vehicle {\n          id\n          vehicleId\n          displayName\n          skydioSerial\n        }\n        accessPoint {\n          id\n          vehicleId\n          displayName\n          skydioSerial\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8746da32f458f477443f6f137dbeab71";

export default node;
